// extracted by mini-css-extract-plugin
export default {"channelCard":"AZoZb","description":"QQUeD","button":"_3XOUM"};